module.exports = __webpack_public_path__ + "img/uk-gc-2.dae10825.png";